import React from 'react';
import { useAppContext } from '../context/AppContext';

export default function CelebrationModal() {
  const { celebration, setCelebration } = useAppContext();

  if (!celebration) return null;

  const isAll = celebration === 'all';
  const emoji = { calls:'📞', texts:'💬', emails:'📧', all:'🏆' }[celebration];

  return (
    <div className="celeb-overlay" onClick={() => setCelebration(null)}>
      <div className="celeb-box">
        <div className={`celeb-emoji ${isAll ? 'celeb-mega' : ''}`}>{emoji}</div>
        <div className="confetti-wrap">
          {Array.from({length: isAll?30:15}).map((_,i)=>(
            <div key={i} className="confetti-dot" style={{
              left:`${Math.random()*100}%`,
              animationDelay:`${Math.random()*0.6}s`,
              background:['#00ff99','#00e5ff','#ffc800','#ff4d88'][i%4]
            }}/>
          ))}
        </div>
        <h2 className="celeb-title">{isAll ? 'TRIPLE CROWN! 👑' : 'Goal Crushed! 🎉'}</h2>
        <p className="celeb-msg">
          {isAll ? 'You completed ALL activity goals today!' : `You hit your daily ${celebration} goal!`}
        </p>
        <div className="celeb-foot">Keep up the amazing work! 💪</div>
      </div>
    </div>
  );
}
